import React from "react";
import { FontSize, FontWeight, Spacing, background, content } from "@glossy";
import { Elevation } from "@glossy/elevations";
import styled from "@xstyled/styled-components";

export interface IProps {
  title?: string;
  generated?: React.ReactNode;
  timezone?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
  period?: React.ReactNode;
  filters?: React.ReactNode;
}

const Root = styled.div`
  background-color: ${background};
  color: ${content};
  box-shadow: ${Elevation.Soft};
`;

const Top = styled.divBox`
  display: flex;
  justify-content: space-between;
  column-gap: ${Spacing.Medium};
  align-items: center;
  padding: ${Spacing.Large};
`;

const Left = styled.divBox`
  flex-shrink: 0;
  align-items: center;
`;

const Middle = styled.div`
  min-width: 0;
  flex-grow: 1;
  max-width: 100%;
`;

const Right = styled.divBox`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  column-gap: ${Spacing.ExtraSmall};
`;

const PeriodFilters = styled.divBox`
  font-size: ${FontSize.Small};
  border-top: 1px solid ${(props) => content(props, "tertiary")};
  row-gap: ${Spacing.ExtraSmall};
  padding: ${Spacing.Medium} ${Spacing.Large};
`;

const Title = styled.div`
  font-size: ${FontSize.Large};
  font-weight: ${FontWeight.Bold};
  line-height: 30px;
  overflow: hidden;
  /* stylelint-disable-line  */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* stylelint-disable-line  */
  -webkit-box-orient: vertical;
`;

const Subtitle = styled.divBox`
  font-size: ${FontSize.Small};
  color: ${(props) => content(props, "secondary")};
  row-gap: ${Spacing.ExtraSmall};
`;

const MiddleDot = styled.spanBox`
  padding: ${Spacing.ExtraSmall};
`;

const Dot = () => (
  <MiddleDot display={{ xs: "none", sm: "inline" }}>•</MiddleDot>
);

const InsightPagesSubheader2 = ({
  title,
  generated,
  timezone,
  period,
  filters,
  left,
  right,
}: IProps) => (
  <Root>
    <Top
      flexDirection={{ xs: "column-reverse", sm: "row" }}
      padding={{
        xs: `${Spacing.Medium} ${Spacing.Large}`,
        sm: Spacing.Large,
      }}
    >
      {!!left && <Left display={{ xs: "none", sm: "flex" }}>{left}</Left>}
      {(!!title || !!timezone) && (
        <Middle>
          <Title>{title}</Title>
          <Subtitle
            display={{ xs: "flex", sm: "block" }}
            flexDirection={{ xs: "column", sm: undefined }}
          >
            {!!generated && <span>{generated}</span>}
            {!!generated && <Dot />}
            <span>{timezone}</span>
          </Subtitle>
        </Middle>
      )}
      {!!right && (
        <Right margin={{ xs: `${Spacing.Medium} 0`, sm: 0 }}>{right}</Right>
      )}
    </Top>
    {(!!filters || !!period) && (
      <PeriodFilters
        display={{ xs: "flex", sm: "block" }}
        flexDirection={{ xs: "column", sm: undefined }}
        padding={{
          xs: `${Spacing.Medium} 0`,
          sm: `${Spacing.Medium} ${Spacing.Large}`,
        }}
        margin={{
          xs: `0 ${Spacing.Large}`,
          sm: 0,
        }}
      >
        {!!period && <span>{period}</span>}
        {!!filters && !!period && <Dot />}
        {!!filters && <span>{filters}</span>}
      </PeriodFilters>
    )}
  </Root>
);

export default InsightPagesSubheader2;
